import _ from 'lodash';

const DEFAULT_ERROR_MESSAGE = 'An error has occurred.  Please try again later.';

export default function errorMessage(e) {
    if( _.isString(e) ) return e;
    return _.get(e, 'response.data.message', e.message || DEFAULT_ERROR_MESSAGE)
}